import { Clock } from "lucide-react";
import type { Vertical } from "@/types/common";

const COPY: Record<Vertical, string> = {
  travel:
    "Package prices are indicative and subject to availability. Final prices are confirmed at booking via our travel partners. BNPL approval is subject to provider eligibility.",
  education:
    "School fee estimates are based on published fee schedules via Zendi and Skiply. Fees vary by year group, curriculum, and term. Confirm exact amounts with the school directly.",
  healthcare:
    "Treatment prices and BNPL availability are sourced from provider catalogues and verified monthly. Always confirm final costs and financing options directly with the healthcare provider at checkout.",
};

export default function DataFreshnessNotice({ vertical }: { vertical: Vertical }) {
  const now = new Date();
  const label = now.toLocaleDateString("en-GB", { month: "long", year: "numeric" });

  return (
    <div className="w-full bg-[hsl(36_39%_93%)] border-b border-border">
      <div className="container mx-auto px-4 py-3 flex items-start md:items-center gap-3 md:flex-row flex-col">
        <div className="flex items-start gap-2 flex-1">
          <Clock className="h-4 w-4 text-primary mt-0.5 shrink-0" />
          <p className="text-sm text-foreground/80 font-body leading-relaxed">
            {COPY[vertical]}
          </p>
        </div>
        <span className="text-[10px] font-mono text-muted-foreground whitespace-nowrap">
          Last updated: {label}
        </span>
      </div>
    </div>
  );
}
